<div class="payment-modal">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-content">
      <div class="icon-wrapper">
        <i data-feather="credit-card"></i>
      </div>
      <h2>Cuotas y Medios de Pago</h2>
    </div>
    <button class="btn-close" (click)="closeDialog()">
      <i data-feather="x"></i>
    </button>
  </div>

  <!-- Payment Methods -->
  <div class="payment-methods">
    <div class="methods-label">
      <i data-feather="check-circle"></i>
      <span>Medios de pago aceptados</span>
    </div>
    <div class="cards-grid">
      <div class="card-badge">
        <img src="/assets/img/credit-cards/Maestro.png" alt="Maestro" />
      </div>
      <div class="card-badge">
        <img src="/assets/img/credit-cards/cabal.png" alt="Cabal" />
      </div>
      <div class="card-badge">
        <img src="/assets/img/credit-cards/Visa.png" alt="Visa" />
      </div>
      <div class="card-badge">
        <img src="/assets/img/credit-cards/Mastercard.png" alt="Master Card" />
      </div>
      <div class="card-badge">
        <img src="/assets/img/credit-cards/mutual-card.png" alt="Mutual Card" />
      </div>
    </div>
  </div>

  <!-- Installments Tables -->
  <div class="installments-container">
    <!-- MutualCard -->
    <div class="installment-group">
      <div class="group-header">
        <div class="header-left">
          <i data-feather="credit-card"></i>
          <h3>MutualCard</h3>
        </div>
        <span class="badge warning">Tarjeta MutualCard</span>
      </div>
      
      <div class="installments-table">
        <div class="table-header">
          <div class="col-cuotas">Cuotas</div>
          <div class="col-price">Precio por Cuota</div>
          <div class="col-total">Total</div>
        </div>
        
        <div class="table-body">
          <ng-container *ngFor="let item of dataItemsTable">
            <div class="table-row" *ngIf="item.type === 1">
              <div class="col-cuotas">
                <div class="cuotas-badge">{{ formatCuotas(item.title) }}</div>
              </div>
              <div class="col-price">
                <span class="price-value">{{ formatPrice(item.id) }}</span>
              </div>
              <div class="col-total">
                <span class="total-value">{{ formatPrice(item.percent) }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Visa / MasterCard / Cabal -->
    <div class="installment-group">
      <div class="group-header">
        <div class="header-left">
          <i data-feather="credit-card"></i>
          <h3>Visa / MasterCard / Cabal</h3>
        </div>
        <span class="badge info">Tarjetas de crédito</span>
      </div>
      
      <div class="installments-table">
        <div class="table-header">
          <div class="col-cuotas">Cuotas</div>
          <div class="col-price">Precio por Cuota</div>
          <div class="col-total">Total</div>
        </div>
        
        <div class="table-body">
          <ng-container *ngFor="let item of dataItemsTable">
            <div class="table-row" *ngIf="item.type === 0">
              <div class="col-cuotas">
                <div class="cuotas-badge">{{ formatCuotas(item.title) }}</div>
              </div>
              <div class="col-price">
                <span class="price-value">{{ formatPrice(item.id) }}</span>
              </div>
              <div class="col-total">
                <span class="total-value">{{ formatPrice(item.percent) }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button class="btn-continue" (click)="closeDialog()">
      <i data-feather="arrow-right"></i>
      Seguir navegando
    </button>
  </div>
</div>
